import { cx } from 'emotion';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ListItem from '@ublend-npm/aulaui-next-web/ListItem';
import Collapse from '@material-ui/core/Collapse';

import SectionListItem from './SectionListItem.container';
import FolderListItemMenu from './FolderListItemMenu.container';
import MaterialVisibilityToggle from './MaterialVisibilityToggle.container';
import AddSectionButton from './AddSectionButton.container';
import { listItem, hiddenListItem } from './MaterialListItem.styled';
import {
  ExpandedFolderIcon,
  CollapsedFolderIcon,
  SectionList,
  FolderButtons,
  folderItem,
} from './FolderListItem.styled';
import { useDrag, useDrop } from './MaterialListItem.dnd';

const CLASSES = {
  text: 'label',
};

const FolderListItem = (props) => {
  const {
    materialId,
    expanded,
    hidden,
    toggleFolder,
    materialIds,
    isInstructor,
    onReorder,
    educatorOnly,
    ...otherProps
  } = props;
  const listItemRef = useRef(null);
  const dragDropProps = { ...props, isFolder: true, parent: null };
  const [{ isDragging }, drag] = useDrag(dragDropProps);
  const [{ dropType }, drop] = useDrop(dragDropProps, listItemRef);
  const ariaLabelId = `folder-button-${materialId}`;

  drag(drop(listItemRef));

  return (
    <React.Fragment>
      <li ref={listItemRef}>
        <ListItem
          component="div"
          textTruncate
          className={cx(listItem, folderItem, hidden && hiddenListItem)}
          classes={CLASSES}
          leftDecoration={
            expanded ? <ExpandedFolderIcon /> : <CollapsedFolderIcon />
          }
          rightDecoration={
            isInstructor ? (
              <FolderButtons id={ariaLabelId}>
                <FolderListItemMenu
                  materialId={materialId}
                  ariaLabelId={ariaLabelId}
                  educatorOnly={educatorOnly}
                />
                {!educatorOnly && (
                  <MaterialVisibilityToggle isFolder materialId={materialId} />
                )}
              </FolderButtons>
            ) : null
          }
          onClick={toggleFolder}
          isDraggable
          isDragging={isDragging}
          dropType={dropType}
          attributes={{
            'aria-expanded': expanded,
            'data-testid': 'material-folder',
          }}
          {...otherProps}
        />
      </li>
      <Collapse aria-hidden={!expanded} in={expanded} component="li">
        <SectionList component="ul">
          {materialIds.map((id) => (
            <SectionListItem
              educatorOnly={educatorOnly}
              key={id}
              materialId={id}
            />
          ))}
          {isInstructor ? (
            <AddSectionButton
              folderId={materialId}
              educatorOnly={educatorOnly}
            />
          ) : null}
        </SectionList>
      </Collapse>
    </React.Fragment>
  );
};

FolderListItem.propTypes = {
  materialId: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
  materialIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isInstructor: PropTypes.bool.isRequired,
  toggleFolder: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  educatorOnly: PropTypes.bool,
};

FolderListItem.defaultProps = {
  educatorOnly: false,
};

export default FolderListItem;
